/* eslint-disable i18next/no-literal-string --
 * React Query cache keys.
 */
/**
 * `entities/taxonomy` TanStack Query key factory.
 *
 * Surface:
 *   - `TAXONOMY_QUERY_KEYS.all`            → `['taxonomies']`
 *   - `TAXONOMY_QUERY_KEYS.list()`         → `['taxonomies', 'list']`
 *   - `TAXONOMY_QUERY_KEYS.detail(id)`     → `['taxonomies', 'detail', id]`
 *   - `TAXONOMY_QUERY_KEYS.changeLog(id)`  → `['taxonomies', 'detail', id, 'change-log']`
 */
export const TAXONOMY_QUERY_KEYS = {
  all: ['taxonomies'] as const,

  list: () => [...TAXONOMY_QUERY_KEYS.all, 'list'] as const,

  detail: (id: string) => [...TAXONOMY_QUERY_KEYS.all, 'detail', id] as const,

  changeLog: (id: string) => [...TAXONOMY_QUERY_KEYS.detail(id), 'change-log'] as const,
} as const;
